import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import { endpoint } from "views/pages/manage/common/constant";
import { masterServiceEndpoints } from "views/pages/manage/common/constant/endpoints/masterServices";
import {
  fetchAllPromisedData,
  fetchAllPostPromisedData,
} from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

export const getTestMappings = async (offset = 0, limit = 50, payload) => {
  return await fetchAllPostPromisedData(
    `${masterServiceEndpoints.courseCatalog.getMappingByCourseId}?offset=${offset}&limit=${limit}`,
    payload,
    "post",
  );
};

export const createTestMapping = async (payload) => {
  const response = await fetchAllPostPromisedData(
    masterServiceEndpoints.courseCatalog.createTestMapping,
    payload,
    "post",
  );
  return response || null;
};

export const updateTestMapping = async (payload) => {
  const response = await fetchAllPostPromisedData(
    masterServiceEndpoints.courseCatalog.updateMapping,
    payload,
    "put",
  );
  return response || null;
};

export const getTermOptions = async () => {
  return await fetchAllPromisedData(masterServiceEndpoints.term.getAllActive);
};

export const getDropdowns = async () => {
  const [dropdowns] = await Promise.all([
    fetchAllPromisedData(endpoint.courseCatelogMapping.getAllActiveCourseIds),
  ]);
  return {
    mapCourseIds:
      dropdowns.map((course) => ({ label: course, value: course })) || [],
    dealType: [
      { label: "B2B", value: "B2B" },
      { label: "B2C", value: "B2C" },
    ],
    concession: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
  };
};

export const checkSipCourseValidation = (
  userDataList,
  courseConfig,
  cridValue,
) => {
  if (cridValue !== "SCHL") return true;
  else {
    if (!courseConfig?.dealType) {
      failureToast("Please select a Deal Type to proceed.");
      return false;
    }
  }
  return true;
};

export const checkConfigValidation = (data) => {
  debugger;
  if (data.dealType?.label === "B2B") {
    if (
      !data.minimumGuarantee ||
      data.concession === null ||
      data.concession === undefined ||
      !data.mapCourseIds?.length
    ) {
      failureToast("Please fill all mandatory fields for B2B deal type.");
      return false;
    }
  } else if (data.dealType?.label === "B2C") {
    if (!data.agreementFilePath) {
      failureToast("Please upload the agreement copy for B2C deal type.");
      return false;
    }
  }
  return true;
};

export const buildCourseMappingConfigDto = (configForm, courseDetail) => {
  return {
    courseId: courseDetail.courseId || null,
    courseDescription: courseDetail?.courseDesc || null,
    courseAttribute: "CRID",
    courseAttributeValue: "SCHL",
    dealType: configForm.dealType?.value || null,
    minimumGuarantee: configForm.minimumGuarantee || null,
    mapCourseIds: configForm?.mapCourseIds?.map((c) => c.value) || [],
    concession: configForm.concession?.value,
    s3Key: configForm.agreementFilePath || null,
    fileName: configForm.agreementFileName || null,
  };
};

// create empty form object
export const initialConfigForm = {
  dealType: null,
  minimumGuarantee: null,
  mapCourseIds: [],
  concession: null,
  agreementFilePath: null,
  agreementFileName: null,
};
export const reduceResponseToSingleObj = (data = []) => {
  if (!Array.isArray(data) || data.length === 0) return {};

  return data.reduce((acc, curr, index) => {
    if (index === 0) {
      return {
        ...curr,
        mapCourseIds: [curr.mapCourseIds],
      };
    }

    acc.mapCourseIds.push(curr.mapCourseIds);
    return acc;
  }, {});
};
